import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIChapterHistory = (namespace: CreateNS) => {
    namespace('chapterHistory')(({ func, prop, deps }) => {
        func('getChapterFromPath', deps.getChapterFromPath);
        prop('currentChapter', deps.getCurrentChapter, {
            setter: deps.setCurrentChapter,
        });
    });
};
